'use strict';

import {fnToastrFormError, getSelectedCompanyForUser, pjaxRedirect, printResponse} from "../jquery-functions-library";

export var fnPayrollNav = function () {

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $(this).find('[name="_token"]').val()}});

    var formGenerate = '#form-generate-excel';
    var formOpen = '#form-open-sheet';

    var btnDelete = '.btn-payroll-delete';

    function createPayroll(action, data, callback) {

        $.ajax({
            type: 'POST',
            url: action,
            data: data,
            success: function (response) {

                $('#datatable-existing-payrolls').DataTable().ajax.reload(null, false);

                if (response.success !== undefined) toastr.success(response.success);
                if (response.info !== undefined) toastr.info(response.info);
                if (response.warning !== undefined) toastr.warning(response.warning);

                if (callback) {
                    callback();
                }
            },
            error: fnToastrFormError,
        });
    }

    $(document).off('submit', formGenerate).on('submit', formGenerate, function (e) {

        e.preventDefault();

        var data = $(this).serialize();
        var url = '/salary/payrolls/' + getSelectedCompanyForUser() + '/create';
        var modalName = '#modal-create-current-payroll';

        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: function (html) {

                if (html.warning) {
                    toastr.warning(html.warning);
                } else if (html.info) {
                    toastr.info(html.info);
                } else {

                    $('.dynamic-modal-container').append(html);

                    var modal = $(modalName);
                    modal.modal('show');

                    var $form = $('#form-store-selections-company');
                    $form.off('submit').on('submit', function (e) {

                        e.preventDefault();

                        data += '&' + $(this).serialize();

                        createPayroll($form.attr('action'), data, function () {
                            modal.modal('hide');
                        });
                    });

                    modal.off('hidden.bs.modal').on('hidden.bs.modal', function () {
                        modal.remove();
                    });
                }
            },
            error: fnToastrFormError,
        });
    });

    $(document).off('submit', formOpen).on('submit', formOpen, function (e) {

        e.preventDefault();

        console.log($(this).attr('data-href'));

        var formArray = $(this).serializeArray();

        for (var i = 0; i < formArray.length; i++) {

            //redirect if salary_id
            if (formArray[i].name === 'salary_id') {
                pjaxRedirect('/salary/payrolls/' + formArray[i].value + '/edit');
            }
        }
    });

    $(document).off('click', btnDelete).on('click', btnDelete, function (e) {

        e.preventDefault();

        var data = {
            id: $(this).attr('data-id')
        };
        var url = $(this).attr('data-href');

        var lang = allLangFiles.salary.js;

        $.confirm({
            title: lang.delete_title,
            content: lang.delete_content,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        $.ajax({
                            method: 'POST',
                            data: data,
                            url: url,
                            success: function (response) {
                                printResponse(response);

                                $('#datatable-existing-payrolls').DataTable().ajax.reload(null, false);
                            },
                            error: fnToastrFormError,
                        });
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                }
            }
        });
    });
};